import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'

import { Button, useErrorService, ABSpinner } from '@abroad/components'
import API from '../../utils/API'
import { useHistory } from 'react-router-dom'
import { formatDate } from '../../utils/date'

const QuestVideo = () => {
  const history = useHistory()
  const Error = useErrorService()
  const [videoAllDetails, setVideoAllDetails] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const getVideoAll = async () => {
      try {
        const { data } = await API.AdminAPI.quests.getAllVideo()
        setVideoAllDetails(data)
        setIsLoading(false)
      } catch (e) {
        Error.showError(e)
        setIsLoading(false)
      }
    }
    getVideoAll()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <>
        <div className='d-flex justify-content-end'>
          <div>
            <Button
              variant='gray'
              className='px-4 py-3 abroad-blue mt-3'
              type='button'
              onClick={() =>
                history.push(`/admin/experiences-media/videos/create-new`)
              }>
              ADD NEW VIDEO
            </Button>
          </div>
        </div>
        <Table responsive hover className='mt-4 custom-table'>
          <thead>
            <tr>
              <th>#</th>
              <th>TITLE</th>
              <th className='text-center'>CREATED AT</th>
              <th className='text-center'>ACTION(S)</th>
            </tr>
          </thead>
          {isLoading && (
            <tr>
              <td className='text-center border-0 pt-3' colSpan='5'>
                <ABSpinner />
              </td>
            </tr>
          )}
          {videoAllDetails.length === 0 && !isLoading && (
            <tr>
              <td className='text-center s6 py-3' colSpan='5'>
                No videos yet!
              </td>
            </tr>
          )}
          <tbody>
            {videoAllDetails.length > 0 &&
              videoAllDetails.map((video, index) => (
                <tr key={video.id}>
                  <td>{index + 1}</td>
                  <td>{video.title}</td>
                  <td className='text-center'>
                    {video.createdAt === null
                      ? '-'
                      : formatDate(video.createdAt)}
                  </td>
                  <td
                    className='text-saffron-700 cursor-pointer text-center'
                    onClick={() =>
                      history.push(
                        `/admin/experiences-media/videos/${video.id}/detail`,
                      )
                    }>
                    Manage
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </>
    </>
  )
}

export default QuestVideo
